import { useState } from "react";
import { i18n } from '../../lang/i18n';
import { renderIcon } from "../../common/Medias";
import ScrollToTop from "../../components/ScrollToTop";

interface Props
{
    recipe: any
}
export default function BrewScreen(props: Props)
{
    const [cups, setCups] = useState(0)
    const method = props.recipe
    return (
        <div className="container recipe">
            <ScrollToTop />
            <div style={{ flex: 1 }}>
                <div className="recipe-image" style={{ backgroundImage: 'url("' + method.photo.url250 + '")' }}>
                </div>
                <div className="recipe-title">
                    {method.name}
                </div>
                {method.cups.length > 1 && <div style={{ fontSize: 17, margin: 10, textAlign: 'center', color: '#9f205c' }}>
                    {i18n.RecipeScreen.SelectTotalCups}</div>}
                {method.cups.length > 1 && <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                    {method.cups.map((item: any, index: number) => (
                        <div key={index} onClick={() => setCups(index)}
                            style={{ width: 90, flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: 10 }}>
                            <div style={cups === index ? styles.cup_selected : styles.cup}>{item.cups} {renderIcon('brew-cup')}</div>
                        </div>
                    ))}
                </div>}
                <div style={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'row',
                    margin: 5,
                    marginBottom: 20
                }}>
                    <div style={styles.col}>
                        {renderIcon('brew-coffee-beans')}
                        <div style={styles.textLine}>{i18n.RecipeScreen.Coffee}</div>
                        <div style={styles.textLineCenterBold}>{method.cups[cups].coffee}</div>
                    </div>
                    <div style={styles.col}>
                        {renderIcon('brew-water')}
                        <div style={styles.textLine}>{i18n.RecipeScreen.Water}</div>
                        <div style={styles.textLineCenterBold}>{method.cups[cups].water}</div>
                    </div>
                    <div style={styles.col}>
                        {renderIcon('brew-temperature')}
                        <div style={styles.textLine}>{i18n.RecipeScreen.Temperature}</div>
                        <div style={styles.textLineCenterBold}>{method.temperature}</div>
                    </div>
                </div>
                <div className="recipe-info">
                    <div className="recipe-label">{i18n.RecipeScreen.Method}</div>
                    <div className="recipe-value">{method.method}</div>
                </div>
                <div className="recipe-info">
                    <div className="recipe-label">{i18n.RecipeScreen.GrindRange}</div>
                    <div className="recipe-value">{method.grindRange}</div>
                </div>
                <div className="recipe-info">
                    <div className="recipe-label">{i18n.RecipeScreen.Time}</div>
                    <div className="recipe-value">{method.time}</div>
                </div>
                <div className="recipe-title" style={{ fontSize: 25, margin: 15, textAlign: 'center' }}>
                    {i18n.RecipeScreen.Steps}
                </div>
                <div style={{ padding: 20, marginBottom: 20 }}>
                    {method.steps.map((item: any, index: number) => (
                        <div key={index} className="recipe-step"
                            style={{
                            }}>
                            <div className="recipe-step-number">{index + 1}</div>
                            <div className="recipe-step-text">{item}</div>
                        </div>
                    ))}
                </div>
                {method.description.length > 0 && <div className="recipe-title" style={{ fontSize: 25, margin: 15, textAlign: 'center' }}>
                    {i18n.RecipeScreen.Notes}
                </div>}
                <div style={{ padding: 20, marginBottom: 10 }}>
                    {method.description.map((item: any, index: number) => (
                        <label key={index} style={{ flex: 1, flexDirection: 'column', fontSize: 15 }}>{item}</label>
                    ))}
                </div>
            </div>
        </div>
    )
}
const styles: any = {
    row: {
        flex: 1,
        flexDirection: 'row',
        marginHorizontal: 5,
    },
    col: { flex: 1, flexDirection: 'column', textAlign: 'center' },
    boxInfo: { flex: 1, flexDirection: 'row', borderColor: 'whitesmoke', marginVertical: 10, borderBottomWidth: 1, paddingBottom: 10 },
    boxLabel: { flex: 1, flexDirection: 'column', textAlign: 'right', marginRight: 5, fontSize: 17 },
    boxValue: { flex: 1, flexDirection: 'column', fontWeight: 'bold', fontSize: 16 },
    textLine: { flex: 1, flexDirection: 'row', textAlign: 'center', fontSize: 12 },
    textLineCenterBold: { flex: 1, flexDirection: 'row', textAlign: 'center', fontWeight: 'bold', fontSize: 17 },
    iconLine: { height: 30, textAlign: 'center', fontSize: 20, marginTop: 20 },
    cup: {
        opacity: 0.3, fontSize: 30, textAlign: 'center',
        color: 'gray',
        padding: 2,
    },
    cup_selected: {
        fontSize: 30, textAlign: 'center',
        color: '#9f205c',
        padding: 2
    }
};

